// extracted by mini-css-extract-plugin
module.exports = {"badge":"badge-3beoC","tooltip":"tooltip-31muY","inner":"inner-1H9wv","shadow":"shadow-3Zd4a","wrapper":"wrapper-38lzD"};